







































































































































































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import DatePicker from "vuejs-datepicker";
import { GapPatientFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class PatientFilter extends Vue {
  id = "patient-filter-popover";
  target = "patient-filter-target";
  filter = this.defaultFilter();
  insurers = Array<any>();
  ipas = Array<any>();
  insurersSelected =[];
  showInsurerSelect = false;
  showIPASelect = false;
  defaultFilter(): GapPatientFilter {
    return {
      id: "",
      firstName: "",
      lastName: "",
      insurerMemberId: "",
      EMR_ID: "",
      birthdateFrom: null,
      birthdateTo: null,
      city: "",
      gender: "",
      phone: "",
      insurerList:[],
      ipaList:[]
    };
  }
  search() {
    //x=2;
    
    this.filter.insurerList = JSON.parse(JSON.stringify(this.checkedInsurers));
    this.filter.ipaList = JSON.parse(JSON.stringify(this.checkedIPAs));
    
    const filter = { ...this.filter };
    this.$store.commit("gaps/SET_PATIENT_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.$store.commit("gaps/SET_PATIENT_FILTER", this.filter);
    //this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  get checkedInsurers(): Array<any> {
    return this.insurers
      .filter((i) => {
        return i.checked;
      })
      .map((i) => i.id);
  }

  get checkedIPAs(): Array<any> {
    return this.ipas
      .filter((i) => {
        return i.checked;
      })
      .map((i) => i.name);
  }
  mounted() {
    const { patient } = this.$store.state.gaps.filter;
    this.filter = JSON.parse(JSON.stringify(patient));
    this.insurers = JSON.parse(JSON.stringify(this.$store.state.gaps.insurers)).map((i) => {
      i.checked = patient.insurerList.includes(i.id);
      return i;
    });

    this.ipas = JSON.parse(JSON.stringify(this.$store.state.gaps.ipas)).map((i) => {
      i.checked = patient.ipaList.includes(i.name);
      return i;
    });

  }
}
